const getPlanNames = (plans) => plans.map((plan) => plan.name).reverse();

export default getPlanNames;
